<dt-modal-content (closeClick)="dialogRef.close()" [contentPadding]="false" [flexContent]="true" [showFooter]="!consent">
  <ng-template #title>Videos</ng-template>
  <ng-template #content>
    @if (!consent) {
      <div class="container">
        <p
          >Der an dieser Stelle eingebundene Inhalt führt Dich auf Seiten, die von der von Google betriebenen Seite YouTube - YouTube, LLC,
          901 Cherry Ave., San Bruno, CA 94066, USA - zur Verfügung gestellt werden. Mit dem Aufruf des Inhalts kann YouTube Deine
          IP-Adresse und die Sprache des Systems, sowie verschiedene browserspezifische Angaben ermitteln.</p
        >
        <p
          >Wenn Du in Deinem YouTube-Account eingeloggt bist, ermöglichst Du YouTube, Dein Surfverhalten direkt Deinem persönlichen Profil
          zuzuordnen. Dies kannst Du verhindern, indem Du Dich aus Deinem YouTube-Account ausloggst.</p
        >
        <p
          >YouTube verwendet Cookies und Tracking-Tools. Die Datenverarbeitungsvorgänge sowie die Zwecke der Verarbeitung können direkt bei
          <a href="https://policies.google.com/privacy?hl=de&gl=de">YouTube</a> erfragt und eingesehen werden.</p
        >
        <p
          >Mit dem Klick auf den Button "Zustimmen" willigst Du ein, die von der Plattform zur Verfügung gestellten Dokumente unter den
          angegebenen Umständen nutzen zu wollen.</p
        >
      </div>
    }

    @if (consent) {
      <div class="content-wrapper">
        <div class="frame-container">
          <mat-spinner diameter="56"></mat-spinner>
          <iframe
            [src]="'https://www.youtube-nocookie.com/embed/' + selectedYoutubeIdWithTime | safeUrl"
            frameborder="0"
            allow="encrypted-media"
            allowfullscreen
          ></iframe>
        </div>
        @if (categories.length === 0 || videos.length === 0) {
          <div class="no-videos-message">Derzeit sind keine Videos vorhanden. Bitte versuche es später erneut.</div>
        } @else {
          <div class="video-browser">
            <div class="categories-area">
              <mat-tab-group mat-stretch-tabs color="accent" mat-align-tabs="center" [(selectedIndex)]="selectedTabIndex">
                <mat-tab labelClass="categories-area-label">
                  <ng-template i18n mat-tab-label><label>Schritte</label></ng-template>
                  <ng-template matTabContent>
                    @for (step of shownSteps; track step; let stepIdx = $index) {
                      <div class="category" [class.selected]="selectedStepIdx === stepIdx" (click)="selectedStepIdx = stepIdx">{{
                        step
                      }}</div>
                    }
                  </ng-template>
                </mat-tab>
                <mat-tab labelClass="categories-area-label">
                  <ng-template i18n mat-tab-label><label>Themengebiete</label></ng-template>
                  <ng-template matTabContent>
                    @for (category of categories; track category; let categoryIdx = $index) {
                      <div
                        class="category"
                        [class.selected]="selectedCategoryIdx === categoryIdx"
                        (click)="selectedCategoryIdx = categoryIdx"
                        >{{ category.name }}</div
                      >
                    }
                  </ng-template>
                </mat-tab>
              </mat-tab-group>
            </div>
            <div class="videos-area">
              @for (video of displayedVideos; track video) {
                <div
                  class="video-entry"
                  [class.selected]="video.youtubeId === selectedYoutubeId"
                  (click)="selectVideo(video.youtubeId)"
                  [title]="video.name"
                >
                  <div class="thumbnail">
                    <mat-icon>smart_display</mat-icon>
                    <img [src]="'//img.youtube.com/vi/' + video.youtubeId + '/mqdefault.jpg'" />
                  </div>
                  <div class="video-title">{{ video.name }}</div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="accent" (click)="consent = true">Zustimmen</button>
    <button mat-raised-button color="accent" (click)="dialogRef.close()">Ablehnen</button>
  </ng-template>
</dt-modal-content>
